import { HistoryEvent } from '@api/types';

export interface NameParser {
  check(event: HistoryEvent): boolean;

  getName(event: HistoryEvent): string;
}

class Store {
  private parsers: NameParser[] = [];

  getName(event: HistoryEvent): string {
    for (const parser of this.parsers) {
      if (parser.check(event)) {
        return parser.getName(event);
      }
    }
    return event.attributes.name;
  }

  register = (parser: NameParser) => {
    this.parsers.push(parser);
  };
}

const store: Store = new Store();

export function registerPrepareNames(onRegisterName: (register: PickOne<Store, 'register'>) => void): void {
  onRegisterName(store.register);
}

export function getPreparedName(event: HistoryEvent): string {
  return store.getName(event);
}
